import { Component, Input, input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { changeLanguage, logout } from 'src/app/root-store/actions';
import { AppState } from 'src/app/root-store/state';
import { User } from 'src/app/user/shared/models/user-model';

@Component({
    selector: 'app-header-admin',
    templateUrl: './header-admin.component.html',
    styleUrls: ['./header-admin.component.scss'],
    standalone: false
})
export class HeaderAdminComponent {

  @Input() isSignedIn: boolean;
  @Input() user: User;
  @Input() currentLanguage: string;
  @Input() languages: string[] = [];
  @Input() providerWebsiteId: number;
  showAppsLauncher = input(true);

  isBurgerMenuOpen = false;
  isAccountMenuOpen = false;

  // 3x3 dot grid of the apps launcher, rendered purely from css
  readonly appsLauncherDots = Array(9);

  public isActive(url: string){
    return this.router.isActive(url, { paths: 'exact', queryParams: 'exact', fragment: 'ignored', matrixParams: 'ignored'});
  }

  constructor(private store: Store<AppState>, private router: Router) { }

  // first letters of the name and surname, shown inside the avatar circle
  get initials(): string {
    return [this.user?.name, this.user?.surname]
      .map(part => part?.trim()?.charAt(0) ?? '')
      .join('')
      .toUpperCase();
  }

  closeAllMenus(){
    this.isBurgerMenuOpen = false;
    this.isAccountMenuOpen = false;
  }

  toggleBurgerMenu() {
    this.isBurgerMenuOpen = !this.isBurgerMenuOpen;
    this.isAccountMenuOpen = false;
  }

  toggleAccountMenu() {
    this.isAccountMenuOpen = !this.isAccountMenuOpen;
  }

  selectLanguage(language: string) {
    if (language === this.currentLanguage) {
      return;
    }

    this.store.dispatch(changeLanguage({ payload: { languageId: language }}));
  }

  // TODO: the apps launcher (3x3 dot grid) has no target defined in the design yet.
  onAppsLauncherClick() {
    // TODO: implement once the apps launcher content is specified.
  }

  onSignOutClick() {
    this.closeAllMenus();
    this.store.dispatch(logout());
  }
}
